<script setup>
    import { computed, onMounted, watch } from 'vue'
    import TitelBlatt from '@/js/components/ModulHandBuch/TitelBlatt.vue'
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import ModulView from '@/js/components/Modul/ModulView.vue'
    import ModulHandbuchPdfOutput from '@/js/components/ModulHandBuch/ModulHandbuchPdfOutput.vue'
    import { useModuleStore } from '@/js/stores/modul'

    const props = defineProps({
        modulHandbuch: {
            type: Object,
            required: true
        },
        filterModulesForUser: {
            type: Object,
            required: false,
            default: () => null
        }
    })

    const moduleStore = useModuleStore()
    const isLoading = computed(() => moduleStore.isLoading)

    async function loadModules() {
        await moduleStore.fetchModulesByModulhandbuchId(props.modulHandbuch.modulHandbuchId)
    }

    onMounted(loadModules)
    watch(() => props.modulHandbuch, loadModules)

    const modules = computed(() => {
        return props.modulHandbuch.modulIds
            .map((modulId) => moduleStore.getModuleById(modulId))
            .filter(Boolean)
            .filter((module) => {
                if (!props.filterModulesForUser) {
                    return true
                }

                return (
                    module.modulverantwortliche.includes(props.filterModulesForUser) ||
                    module.lehrende.includes(props.filterModulesForUser)
                )
            })
    })
</script>

<template>
    <div id="modulhandbuch-container-wrapper">
        <v-overlay
            :model-value="isLoading"
            contained
            persistent
            class="d-flex align-center justify-center"
        >
            <v-progress-circular color="primary" size="75" indeterminate />
        </v-overlay>

        <div
            v-show="!isLoading"
            id="modulhandbuch-container"
            class="d-flex flex-column flex-nowrap w-100 pb-5"
        >
            <ContentCollapse title="Titelblatt" collapse-key="collapse-titelblatt">
                <TitelBlatt :modul-handbuch="modulHandbuch" />
            </ContentCollapse>
            <ContentCollapse title="Pdf Output" collapse-key="collapse-pdf-output">
                <modul-handbuch-pdf-output v-if="modulHandbuch" :modul-handbuch="modulHandbuch" />
            </ContentCollapse>
            <div v-for="modul in modules" :key="modul.modulId" class="mt-3">
                <ContentCollapse
                    :title="modul.modulname"
                    :collapse-key="modul.modulId"
                    :data-test="`modul-collapse-view-${modul.modulId}`"
                >
                    <modul-view
                        :modul-id="modul.modulId"
                        :data-test="`modul-view-${modul.modulId}`"
                        :modul="modul"
                    />
                </ContentCollapse>
            </div>
        </div>
    </div>
</template>

<script></script>

<style scoped>
    #modulhandbuch-container-wrapper {
        position: relative;
    }
</style>
